import React from "react";

const IconEmptyFlag = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M17.0599 6.78093L4.12242 2.28093C4.03763 2.25141 3.947 2.24262 3.85811 2.2553C3.76922 2.26797 3.68466 2.30173 3.61149 2.35377C3.53832 2.40581 3.47867 2.4746 3.43753 2.55441C3.39639 2.63421 3.37495 2.72271 3.375 2.81249L3.375 15.1875C3.375 15.3367 3.43426 15.4798 3.53975 15.5852C3.64524 15.6907 3.78832 15.75 3.9375 15.75C4.08668 15.75 4.22976 15.6907 4.33525 15.5852C4.44074 15.4798 4.5 15.3367 4.5 15.1875L4.5 12.2126L17.0599 7.84405C17.1705 7.8058 17.2663 7.73405 17.3341 7.63877C17.402 7.5435 17.4384 7.42945 17.4384 7.31249C17.4384 7.19553 17.402 7.08148 17.3341 6.98621C17.2663 6.89094 17.1705 6.81918 17.0599 6.78093ZM4.5 11.0215L4.5 3.60351L15.1629 7.31249L4.5 11.0215Z"
        fill="#343330"
      />
    </svg>
  );
};

export default IconEmptyFlag;
